class OrderConfirmationPrintController {
    constructor($timeout, settings) {
        this.settings = settings;
        $timeout(() => window.print(), 0);
    }

    $onChanges(changes) {
        if (changes.order && changes.order.currentValue) {
            this.isDelivery = this.order.DeliveryMethod === 'Courier' || this.order.DeliveryMethod === 'TPCour' || this.order.DeliveryMethod === 'XpressD';
            this.fulfilmentMethodName = this.isDelivery ? 'Delivery' : 'Pick Up';
            this.recipientHeader = this.isDelivery ? this.settings.orderConfirmation.deliveryMessage : this.settings.orderConfirmation.pickupMessage;
            this.packagingFeeEnabled = this.settings.checkout.enablePackagingPreference && !!this.order.PackagingFeeLabel;
        }
    }
}

const orderConfirmationPrintControllerComponentDefinition = {
    bindings: {
        order: '<',
    },
    controller: ['$timeout', 'Settings', OrderConfirmationPrintController],
    template: require('./order-confirmation-print.component.html').trim(),
};

module.exports = {
    OrderConfirmationPrintController,
    orderConfirmationPrintControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-print.component.js